import { PopoutWrapper, useScrollLock } from "@vkontakte/vkui";
import { usePopout } from "@/core/reatom/state/popout/popout";
import s from "./style.module.scss";

export const Popout = () => {
  const { popout, isOpened, hide } = usePopout();

  useScrollLock(isOpened);

  if (!isOpened) return null;
  
  return (
    <PopoutWrapper
      onClick={(e) => {
        e.stopPropagation();
        hide();
      }}
    >
      <div className={s.popoutWrapper}>{popout}</div>
    </PopoutWrapper>
  );
};
